import axios from 'axios';

export const CE_ARCHIVE = 'CE_ARCHIVE';
export const E_ARCHIVE = 'E_ARCHIVE';
export const RESTORE_ARCHIVED_CAMPAIGN = 'RESTORE_ARCHIVED_CAMPAIGN';
export const DELETE_CAMPAIGN_TO_TRASH = 'DELETE_CAMPAIGN_TO_TRASH';

export function getArchivedCampaignsAndEditions(filter) {
  return {
    type: CE_ARCHIVE,
    payload: axios.get('/api/archiveds/main/campaigns/and/editions.json?' + filter).then(({ data }) => data),
  };
}

export function getArchivedEditions(campaignId) {
  return {
    type: E_ARCHIVE,
    payload: axios.get('/api/archiveds/' + campaignId + '/campaigns/and/editions.json').then(({ data }) => data),
  };
}

export function restoreCampaignR(campaignId, option) {
  return {
    type: RESTORE_ARCHIVED_CAMPAIGN,
    payload: axios.put('/api/campaigns/' + campaignId + '/archives/' + option + '.json').then(({ data }) => data),
  };
}

export function deleteArchivedCampaignR(campaignId) {
  return {
    type: DELETE_CAMPAIGN_TO_TRASH,
    payload: axios.delete('/api/archives/' + campaignId + '/campaign.json').then(({ data }) => data),
  };
}
